export const GET_DYNAMIC_LIST = "GET_DYNAMIC_LIST"
export const GET_DYNAMIC_LIST_SUCCESS = "API_SUCCESS"
export const GET_DYNAMIC_LIST_FAIL = "API_FAIL"

// DYNAMIC DATA

export const GET_DYNAMIC_DATA = "GET_DYNAMIC_DATA"
export const GET_DYNAMIC_DATA_SUCCESS = "GET_DYNAMIC_DATA_SUCCESS"

export const ADD_NEW_DYNAMIC_DATA = "ADD_NEW_DYNAMIC_DATA"
export const ADD_DYNAMIC_DATA_SUCCESS = "ADD_DYNAMIC_DATA_SUCCESS"

export const UPDATE_DYNAMIC_DATA = "UPDATE_DYNAMIC_DATA"
export const UPDATE_DYNAMIC_DATA_SUCCESS = "UPDATE_DYNAMIC_DATA_SUCCESS"

export const DELETE_DYNAMIC_DATA = "DELETE_DYNAMIC_DATA"
export const DELETE_DYNAMIC_DATA_SUCCESS = "DELETE_DYNAMIC_DATA_SUCCESS"

export const DYNAMIC_DATA_API_ERROR = "DYNAMIC_DATA_API_ERROR"